import { createModuleStore } from '@/stores/utils'
const createInitialFilterState = () => {
  return {
    selectedUsers: null,
    startTimestamp: null,
    endTimestamp: null,
    period: 'PAST_WEEK',
  }
}
export const useUserActivityStore = createModuleStore(
  'user-activity-report',
  {
    type: 'User Activity',
    pageHeading: 'User Activity Report',
    noHistory: true,
    noActivate: true,
    noCopy: true,
    noStatus: true,
    noDeactivate: true,
    noDelete: true,
    noTimeline: true,
    noEdit: true,
    noAdd: true,
    uploadOptionsCsv: '',
    uri: '/reports/user-activity',
    serviceUri: '/user-activity',
    sortingOn: 'toolbar',
    statusesFilterName: 'statuses',
    listingModuleName: 'Reports',
    listingActivityName: 'View User Activity Report',
    allFields: [
      {
        key: 'user',
        title: 'USER',
        type: 'user',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'activityName',
        title: 'ACTIVITY NAME',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'moduleName',
        title: 'MODULE NAME',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'numRefreshes',
        title: 'REFRESH COUNT',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'startTimestamp',
        title: 'START TIME',
        type: 'datetime',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'endTimestamp',
        title: 'END TIME',
        type: 'datetime',
        defaultSortBy: true,
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'interactiveTime',
        title: 'INTERACTIVE TIME',
        type: 'millisToHumanReadable',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'navbarTime',
        title: 'NAVBAR TIME',
        type: 'millisToHumanReadable',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'filterTime',
        title: 'FILTER TIME',
        type: 'millisToHumanReadable',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'waitTime',
        title: 'WAIT TIME',
        type: 'millisToHumanReadable',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'contentTime',
        title: 'CONTENT TIME',
        type: 'millisToHumanReadable',
        visible: true,
        sortable: true,
        disabled: false,
      },
    ],
  },
  {
    supportedPageFilters: {
      periodApplicable: 'true',
      selectedUsers: {
        type: 'users',
        multiple: true,
        placeholder: 'Pick one or more users to filter',
        optionsLabel: 'name',
        submitValueKey: 'externalId',
      },
    },
    filters: createInitialFilterState(),
  },
  {
    resetPageFilters() {
      const store = useUserActivityStore()
      store.filters = createInitialFilterState()
      store.supportedPageFilters.periodApplicable = 'true'
      store.resetBaseFilters()
    },
  },
  {}
)
